import { render, staticRenderFns } from "./CreateShelterStatus.vue?vue&type=template&id=43140a10&"
import script from "./CreateShelterStatus.vue?vue&type=script&lang=js&"
export * from "./CreateShelterStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports